<template>
    <div>
        <el-row class="bottom20">
            <el-table :data="page.records">
                <el-table-column prop="roomIds">
                    <template slot="header" slot-scope="scope">
                        数据中心<br>
                        <dictionary-select v-model="pageSearch.search.cts_roomId" :factory-name="'room'" :params="{type: 'AUTH_SITE'}"
                                           :clearable="true" size="mini">
                        </dictionary-select>
                    </template>
                    <template slot-scope="scope">
                        <div v-if="scope.row.originalContractRoomIdsArray != null && scope.row.originalContractRoomIdsArray.length > 0">
                            <span v-for="(roomId, index) in scope.row.originalContractRoomIdsArray" :key="index">
                                <dictionary-text :factory-name="'room'" :params="{type: 'ALL'}" :value="roomId">
                                </dictionary-text>
                                <br/>
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="customerName">
                    <template slot="header" slot-scope="scope">
                        客户名称<br>
                        <customer-select v-model="pageSearch.search.eq_customerId"
                                         @change="pageSearch.search.eq_contractId = null" :filterable="true" :clearable="true"
                                         size="mini">
                        </customer-select>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.originalCustomerName}}
                    </template>
                </el-table-column>
                <el-table-column prop="contractName">
                    <template slot="header" slot-scope="scope">
                        合同名称<br>
                        <contract-select v-model="pageSearch.search.eq_contractId"
                                         :customer-id="pageSearch.search.eq_customerId" :filterable="true" :clearable="true"
                                         size="mini">
                        </contract-select>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.id == null ? scope.row.originalContractName : scope.row.contractName}}
                    </template>
                </el-table-column>

                <el-table-column prop="contractName">
                    <template slot="header" slot-scope="scope">
                        合同编号<br>
                        <div style="height: 40px;"></div>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.id == null ? scope.row.originalContractSid : scope.row.contractSid}}
                    </template>
                </el-table-column>
                <el-table-column prop="sid">
                    <template slot="header" slot-scope="scope">
                        月份<br>
                        <el-date-picker v-model="pageSearch.search.eq_month" value-format="yyyyMM"
                                        type="month" size="mini" placeholder="月份"></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        {{getRowMonth(scope.row)}}
                    </template>
                </el-table-column>

                <el-table-column prop="realName">
                    <template slot="header" slot-scope="scope">
                        费用<br>
                        <div style="height: 40px;"></div>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.amount == null || scope.row.amount === 0 ? '-' : scope.row.amount | athub_currency}}
                    </template>
                </el-table-column>

                <el-table-column prop="workflowStatus">
                    <template slot="header" slot-scope="scope">
                        状态<br>
                        <dictionary-select v-model="pageSearch.search.in_workflowStatus" :multiple="true" :clearable="true" :collapse-tags="true"
                                        :factory-name="'domain'" :params="'CONTRACTBILLSTATUS'" size="mini">
                        </dictionary-select>
                    </template>
                    <template slot-scope="scope">
                        <span>
                        <span v-if="scope.row.workflowStatus == null">-</span>
                        <dictionary-text v-else :factory-name="'domain'" :params="'CONTRACTBILLSTATUS'" :value="scope.row.workflowStatus" size="mini"></dictionary-text>
                        </span>
                    </template>
                    </el-table-column>

                <el-table-column prop="serviceLevel">
                    <template slot="header" slot-scope="scope">
                        操作<br>
                        <div style="height: 40px;"></div>
                    </template>
                    <template slot-scope="scope">
                        <div>
                            <el-button @click="toAdd(scope.row)" v-if="scope.row.status == null" plain size="minimum">创建账单</el-button>
                            <el-button @click="toEdit(scope.row)" v-if="scope.row.status === 0 && ['DRAFT', 'WACHA'].includes(scope.row.workflowStatus)" type="warning" plain size="minimum">账单变更</el-button>
                            <el-button @click="toShow(scope.row)" v-if="scope.row.status != null " plain size="minimum">查看</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
            <el-pagination
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :current-page="pageSearch.current"
                    :page-sizes="[10, 25, 50, 100]"
                    :page-size="pageSearch.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="page.total">
            </el-pagination>
        </el-row>
    </div>
</template>

<script>
import _ from 'lodash'
import {formatDate, prevMonth} from 'element-ui/src/utils/date-util'
import Emitter from 'element-ui/src/mixins/emitter'
import {AuthInfo} from '@/util/user/authInfo'
import {merge} from '@/util'
import DictionarySelect from "@/components/common/DictionarySelect"
import CustomerSelect from '@/views/billing/customer/component/customer.select'
import ContractSelect from '@/views/billing/contract/component/contract.select'
import BillingServer from '@/api/billing'
import {
  COMPONENT_LIST,
  COMPONENT_MAIN,
  FN_LIST_QUERY,
  formatCurrency,
  PERMISSION_DELETE,
  PERMISSION_EDIT,
} from './contract.bill.month.common'
import DictionaryText from "@/components/common/DictionaryText";
import {contractCanAddBillByContractId, contractCanEditBillByContractId} from "../../contract.common";

export default {
        name: COMPONENT_LIST,
        componentName: COMPONENT_LIST,
        mixins: [Emitter],
        inject: ['toDetailShow', 'toDetailAdd', 'toDetailEdit', 'toDetailRemove'],
        props: ['search'],
        components: {DictionaryText, DictionarySelect, CustomerSelect, ContractSelect},
        data() {
            return {
                key: 'id',
                currentRowData: null,
                visited: [],
                pageSearch: {
                    current: 1,
                    size: 10,
                    search: {
                        cts_roomId: null,
                        eq_customerId: null,
                        eq_contractId: null,
                        like_customerName: null,
                        like_contractName: null,
                        eq_month: formatDate(prevMonth(new Date()), 'yyyyMM'),
                        userId: AuthInfo.userId,
                    },
                },
                page: {
                    total: 0,
                    records: []
                },
            };
        },
        computed: {
            editBtnExisted() {
                return (PERMISSION_EDIT == null || this.hasPermission(PERMISSION_EDIT));
            },
            deleteBtnExisted() {
                return (PERMISSION_DELETE == null || this.hasPermission(PERMISSION_DELETE));
            },
        },
        watch: {
            'search': {
                deep: true,
                handler() {
                    this.pageSearch.search = merge(true, {}, this.pageSearch.search, this.search);
                }
            },
            'pageSearch.current': {
                deep: false,
                handler() {
                    this.queryByPage();
                },
            },
            'pageSearch.size': {
                deep: false,
                handler() {
                    this.reQueryByPage();
                },
            },
            'page': {
                deep: true,
                handler(value) {
                    if (value.total > 0) {
                        let record;
                        let records = value.records;
                        if (this.currentRowData != null && this.currentRowData[this.key] != null) {
                            for (let i = 0, l = records.length; i < l; i++) {
                                if (this.currentRowData[this.key] === records[i][this.key]) {
                                    record = records[i];
                                    break;
                                }
                            }
                        }
                        if (record == null) {
                            record = records[0];
                        }
                        this.select(record);
                    }
                },
            },
            'pageSearch.search': {
                deep: true,
                handler(value) {
                    this.reQueryByPage();
                    if (value != null) {
                        this.dispatch(COMPONENT_MAIN, FN_LIST_QUERY);
                    }
                }
            }
        },
        methods: {
            handleCurrentChange(current) {
                this.pageSearch.current = current;
            },
            handleSizeChange(size) {
                this.pageSearch.size = size;
            },
            reQueryByPage() {
                if (this.pageSearch.current === 1) {
                    this.queryByPage();
                } else {
                    this.pageSearch.current = 1;
                }
            },
            checkMonth() {
                let success = true;
                if (this.pageSearch.search.eq_month == null || this.pageSearch.search.eq_month === '') {
                    this.$message.error('请选择月份');
                    success = false;
                }
                return success;
            },
            async doQueryByPage() {
                if (this.checkMonth()) {
                    let res, total = 0, records = [];
                    res = await BillingServer.contractBillMonth.page(this.pageSearch, {loading: true});
                    if (this.isSuccess(res)) {
                        records = res.data.data.records;
                        total = res.data.data.total;
                    }
                    records.forEach(record => {
                        record.originalContractRoomIdsArray = record.originalContractRoomIds == null ? [] :
                            record.originalContractRoomIds.split(',').filter(roomId => roomId.trim() !== '');
                    });
                    this.page = {
                        total: total,
                        records: records,
                    };
                }
            },
            queryByPage: _.debounce(function() {
                this.doQueryByPage();
            }, 200) ,
            query() {
                this.queryByPage();
            },
            reQuery() {
                this.reQueryByPage();
            },
            getRowMonth(row) {
                let month = '';
                function formatMonth(oldMonth) {
                    let formattedMonth = '';
                    if (oldMonth != null && oldMonth !== '') {
                        formattedMonth = oldMonth.substr(0, 4) + '-' + oldMonth.substr(4, 6);
                    }
                    return formattedMonth;
                }
                if (row != null) {
                    month = formatMonth(row.month);
                }
                if (month == null || month === '') {
                    month = formatMonth(this.pageSearch.search.eq_month);
                }
                return month;
            },
            select(data) {
                this.currentRowData = data;
            },
            getSelectedCellClassName({row}) {
                let cellClassName = '';
                if (this.currentRowData && this.currentRowData[this.key] === row[this.key]) {
                    cellClassName += ' currentAccess ';
                }
                return cellClassName;
            },
            visit(data) {
                let id = data[this.key];
                if (this.visited.indexOf(id) === -1) {
                    this.visited.push(id);
                }
            },
            getVisitedRowClassName({row}) {
                let rowClassName = '';
                if (this.visited.indexOf(row[this.key]) !== -1) {
                    rowClassName += ' visited';
                }
                return rowClassName;
            },
            toShow(data) {
                this.toDetailShow(data);
            },
            async toAdd(data) {
                if (this.checkMonth()) {
                  let contractId = data.originalContractId;
                  let can = await contractCanAddBillByContractId(contractId);
                  if (!can) {
                    this.$message.error('该合同还没有通过审批，不能创建账单！');
                    return;
                  }
                  this.toDetailAdd({
                      contractId: contractId,
                      month: this.pageSearch.search.eq_month
                  });
                }
            },
            async toEdit(data) {
              let contractId = data.originalContractId;
              let can = await contractCanEditBillByContractId(contractId);
              if (!can) {
                this.$message.error('该合同还没有通过审批，不能变更账单！');
                return;
              }
              this.toDetailEdit(data);
            },
            toDelete(data) {
                this.toDetailRemove(data);
            },
            isSuccess(res) {
                return String(res.data.code) === '200' || String(res.data.code).toUpperCase() === 'OK' || res.data.success;
            }
        },
        mounted() {
        },
        filters: {
            athub_currency(value, currency, decimals) {
                return formatCurrency(value, currency, decimals);
            }
        }
    }
</script>

<style scoped>

</style>
